import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import type { LevelResult } from '../types/quiz';
interface ResultPanelProps {
  result: LevelResult;
  webinarUrl: string;
  onRestart: () => void;
}
export function ResultPanel({
  result,
  webinarUrl,
  onRestart
}: ResultPanelProps) {
  return <div data-id="element-136" data-mp="hl0jm4q3auhn">
      <p className="font-sans text-sm font-medium tracking-wide text-dorado-deep" data-id="element-137" data-mp="hlilphzfo2xh">
        Tu nivel dominante es
      </p>

      <h2 className="mt-3 font-serif text-4xl leading-tight text-violeta sm:text-5xl" data-id="element-138" data-mp="mjk4e1sy608f">
        {result.name}
      </h2>
      <p className="mt-2 font-sans text-sm text-noche/55" data-id="element-139" data-mp="rhlomq2405lh">{result.stage}</p>

      <p className="mt-8 font-serif text-2xl leading-snug text-noche" data-id="element-140" data-mp="wjugfj38x1m0">{result.headline}</p>

      <p className="mt-5 font-sans text-base leading-relaxed text-noche/75" data-id="element-141" data-mp="10j388ieq6pex">{result.description}</p>

      <div className="mt-10 border-l-2 border-dorado pl-6" data-id="element-142" data-mp="2yb7lq994lbil">
        <h3 className="font-sans text-sm font-semibold uppercase tracking-wide text-noche/60" data-id="element-143" data-mp="32b7y7ocnzcn0">
          Cómo se ve este nivel en tu día a día
        </h3>
        <ul className="mt-4 space-y-2.5" data-id="element-144" data-mp="gdj5uceblrxg">
          {result.signals.map(signal => <li key={signal} className="font-sans text-base leading-relaxed text-noche/80" data-id="element-145" data-mp="bkhnfuewna94">
              {signal}
            </li>)}
        </ul>
      </div>

      <div className="mt-12 bg-violeta px-6 py-8 text-hueso sm:px-8" data-id="element-146" data-mp="1nlitzs4n89u">
        <h3 className="font-serif text-xl text-dorado" data-id="element-147" data-mp="zau1ln0qu385">Tu primer paso para subir de nivel</h3>
        <p className="mt-3 font-sans text-base leading-relaxed text-hueso/85" data-id="element-148" data-mp="z8hl7eamw0x7">{result.firstStep}</p>
      </div>

      <p className="mt-10 font-sans text-base leading-relaxed text-noche/75" data-id="element-149" data-mp="pco3zhlyzj93">
        Te acabamos de enviar tu resultado completo a tu correo, junto con el primer paso para
        empezar a subir de nivel hoy mismo.
      </p>

      <div className="mt-8 flex flex-col items-start gap-4 sm:flex-row sm:items-center" data-id="element-150" data-mp="3a359cr1eycl7">
        <a href={webinarUrl} target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-2 rounded-sm bg-dorado px-8 py-4 font-sans text-base font-semibold text-noche transition-colors duration-150 ease-out hover:bg-dorado-deep focus:outline-none focus-visible:ring-2 focus-visible:ring-violeta focus-visible:ring-offset-2 focus-visible:ring-offset-hueso" data-id="element-151" data-mp="353ahak5wjgyk">
          Unirme al webinar gratis
          <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-152" data-mp="1s736y0u32nex" />
        </a>
        <button type="button" onClick={onRestart} className="font-sans text-sm text-noche/55 underline underline-offset-4 transition-colors duration-150 ease-out hover:text-violeta focus:outline-none focus-visible:ring-2 focus-visible:ring-violeta" data-id="element-153" data-mp="1i9703l86iemm">
          Volver a hacer el test
        </button>
      </div>
    </div>;
}